import { createContext } from 'react'
import { Tracker } from './Tracker'

export const TrackerContext = createContext<Tracker | null>(null)
